/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateExportJobRequest } from '../../models/create-export-job-request';
import { ExportJobDto } from '../../models/export-job-dto';

export interface ExportsPost$Json$Params {
      body?: CreateExportJobRequest
}

export function exportsPost$Json(http: HttpClient, rootUrl: string, params?: ExportsPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportJobDto>> {
  const rb = new RequestBuilder(rootUrl, exportsPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExportJobDto>;
    })
  );
}

exportsPost$Json.PATH = '/exports';
